import request from '@/utils/request'

const prefix = '/django_rest/post-applicant-management'

export default {
  searchMicroSite: (condition) => {
    return request.get(`${prefix}/micro-site/`, { params: condition })
  },
  getMicroSiteById: (id) => {
    return request.get(`${prefix}/micro-site/${id}`)
  },
  getMicroSitePageConfigById: (id) => {
    return request.get(`${prefix}/micro-site/${id}`, { params: { need_detail: true } })
  },
  createMicroSite: (microSite) => {
    return request.post(`${prefix}/micro-site/`, microSite)
  },
  updateMicroSite: (microSite) => {
    return request.put(`${prefix}/micro-site/${microSite.id}`, microSite)
  },

  searchQuestion: (condition) => {
    return request.get(`${prefix}/question/`, { params: condition })
  },
  getQuestionById: (id) => {
    return request.get(`${prefix}/question/${id}`)
  },
  createQuestion: (question) => {
    return request.post(`${prefix}/question/`, question)
  },
  updateQuestion: (question) => {
    return request.put(`${prefix}/question/${question.id}`, question)
  },

  searchQuestionnaire: (condition) => {
    return request.get(`${prefix}/questionnaire/`, { params: condition })
  },
  getQuestionnaireById: (id) => {
    return request.get(`${prefix}/questionnaire/${id}`)
  },
  createQuestionnaire: (questionnaire) => {
    return request.post(`${prefix}/questionnaire/`, questionnaire)
  },
  updateQuestionnaire: (questionnaire) => {
    return request.put(`${prefix}/questionnaire/${questionnaire.id}`, questionnaire)
  },

  searchStep: (condition) => {
    return request.get(`${prefix}/step/`, { params: condition })
  },
  getStepById: (id) => {
    return request.get(`${prefix}/step/${id}`)
  },
  createStep: (step) => {
    return request.post(`${prefix}/step/`, step)
  },
  updateStep: (step) => {
    return request.put(`${prefix}/step/${step.id}`, step)
  },

  searchEmailTemplate: (condition) => {
    return request.get(`${prefix}/email-template/`, { params: condition })
  },
  getEmailTemplateById: (id) => {
    return request.get(`${prefix}/email-template/${id}`)
  },
  sendTestEmail: (emailTemplate) => {
    return request.post(`${prefix}/email-template/${emailTemplate.id}`, emailTemplate)
  },
  updateEmailTemplate: (emailTemplate) => {
    return request.put(`${prefix}/email-template/${emailTemplate.id}`, emailTemplate)
  },

  searchInvitation: (condition) => {
    return request.get(`${prefix}/invitation-record/`, { params: condition })
  },
  updateInvitation: (invitation) => {
    return request.post(`${prefix}/invitation-record/${invitation.id}`, invitation)
  },
  putInvitation: (invitation) => {
    return request.put(`${prefix}/invitation-record/${invitation.id}`, invitation)
  },
  exportInvitation: (condition) => {
    return request.get(`${prefix}/export-invitation/`, { params: condition })
  },
  createInvitation: (invitation) => {
    return request.post(`${prefix}/invitation/`, invitation)
  }
}
